import { Link } from "react-router-dom";
import { categories } from "@/mocks/movies";

export default function CategoryQuickLinks() {
  return (
    <section aria-labelledby="category-quick-title">
      <h2 id="category-quick-title" className="font-heading text-lg font-bold text-foreground-950">
        分类快捷入口
      </h2>
      <p className="mt-1 text-sm text-foreground-500">按类型快速浏览国产影视作品</p>
      <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-3">
        {categories.map((cat, i) => (
          <Link
            key={cat.type}
            to={`/category/${cat.type}`}
            className={`group flex items-center gap-4 overflow-hidden rounded-lg border border-background-200 p-5 transition-colors ${
              i === 0
                ? "bg-primary-50 hover:border-primary-300"
                : i === 1
                  ? "bg-accent-50 hover:border-accent-300"
                  : "bg-secondary-50 hover:border-secondary-300"
            }`}
          >
            <span
              className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg ${
                i === 0
                  ? "bg-primary-500 text-background-50"
                  : i === 1
                    ? "bg-accent-500 text-primary-950"
                    : "bg-secondary-500 text-background-50"
              }`}
            >
              <i className={`${cat.icon} text-2xl`} aria-hidden="true" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block font-heading text-base font-bold text-foreground-950">
                {cat.label}
              </span>
              <span className="mt-1 block line-clamp-2 text-xs leading-relaxed text-foreground-600">
                {cat.desc}
              </span>
            </span>
            <i
              className="ri-arrow-right-s-line shrink-0 text-xl text-foreground-400 transition-transform group-hover:translate-x-1"
              aria-hidden="true"
            />
          </Link>
        ))}
      </div>
    </section>
  );
}